@use "../../styles/breakpoint.module.scss" as *;

.close {
    position: absolute;
    top: var(--spacer-40);
    right: var(--spacer-40);
    padding: 4px;
    color: var(--white);
    z-index: 1;
    width: var(--spacer-48);
    height: var(--spacer-48);

    @media ($below-mobile) {
        padding: 0;
    }

    svg {
        width: var(--spacer-40);
        height: var(--spacer-40);
        padding: var(--spacer-8);
        border: 1.5px solid currentColor;
        border-radius: var(--spacer-40);
        fill: currentColor;

        @media ($below-mobile) {
            padding: 4px;
            border-width: 1px;
        }
    }
}
